"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScrollPosition = exports.bindEvent = void 0;
var bindEvent = function (element, event, callback) {
    if (element.addEventListener) {
        element.addEventListener(event, callback, false);
    }
    else if (element.attachEvent) {
        element.attachEvent("on".concat(event), callback);
    }
};
exports.bindEvent = bindEvent;
/**
 * Helper method that returns the scrolling position
 * @method
 * @static
 * @name getScrollPosition
 * @memberOf TriggerScroll
 * @returns {number} - The scrolling position
 */
var getScrollPosition = function () {
    var rootElem = document.documentElement;
    var bodyElem = document.body;
    return Math.round((rootElem['scrollTop'] || bodyElem['scrollTop']) / ((rootElem['scrollHeight'] || bodyElem['scrollHeight']) - rootElem.clientHeight) * 100);
};
exports.getScrollPosition = getScrollPosition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJzcmMvbGliL3NlcnZpY2VzL3RyaWdnZXJzL2hlbHBlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQU8sSUFBTSxTQUFTLEdBQUcsVUFBQyxPQUFZLEVBQUUsS0FBVSxFQUFFLFFBQTBCO0lBQzFFLElBQUksT0FBTyxDQUFDLGdCQUFnQixFQUFFO1FBQzFCLE9BQU8sQ0FBQyxnQkFBZ0IsQ0FBQyxLQUFLLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxDQUFBO0tBQ25EO1NBQU0sSUFBSSxPQUFPLENBQUMsV0FBVyxFQUFFO1FBQzVCLE9BQU8sQ0FBQyxXQUFXLENBQUMsWUFBSyxLQUFLLENBQUUsRUFBRSxRQUFRLENBQUMsQ0FBQTtLQUM5QztBQUNMLENBQUMsQ0FBQTtBQU5ZLFFBQUEsU0FBUyxhQU1yQjtBQUVEOzs7Ozs7O0dBT0c7QUFDSSxJQUFNLGlCQUFpQixHQUFHO0lBQzdCLElBQU0sUUFBUSxHQUFHLFFBQVEsQ0FBQyxlQUFlLENBQUE7SUFDekMsSUFBTSxRQUFRLEdBQUcsUUFBUSxDQUFDLElBQUksQ0FBQTtJQUM5QixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxRQUFRLENBQUMsV0FBVyxDQUFDLElBQUksUUFBUSxDQUFDLFdBQVcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxjQUFjLENBQUMsSUFBSSxRQUFRLENBQUMsY0FBYyxDQUFDLENBQUMsR0FBRyxRQUFRLENBQUMsWUFBWSxDQUFDLEdBQUcsR0FBRyxDQUFDLENBQUE7QUFDaEssQ0FBQyxDQUFBO0FBSlksUUFBQSxpQkFBaUIscUJBSTdCIn0=